import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["flushX", "flushY", "flushTop", "padding", "children", "containerData", "className", "noPaddingY"];
import React from 'react';
import style from './style.module.scss';

var InputContainer = function InputContainer(_ref) {
  var flushX = _ref.flushX,
      flushY = _ref.flushY,
      flushTop = _ref.flushTop,
      padding = _ref.padding,
      children = _ref.children,
      containerData = _ref.containerData,
      className = _ref.className,
      noPaddingY = _ref.noPaddingY,
      attr = _objectWithoutPropertiesLoose(_ref, _excluded);

  var calculatedClassName = "\n    " + style['input-container'] + "\n    " + (flushY ? style['input-container--flush-y'] : '') + "\n    " + (flushX ? style['input-container--flush-x'] : '') + "\n    " + (flushTop ? style['input-container--flush-top'] : '') + "\n    " + (padding ? style['input-container--padding'] : '') + "\n    " + (noPaddingY ? style['no-padding-y'] : '') + "\n    " + (className ? className : '') + "\n  ";
  var dataAttr = containerData ? {
    'data-container': containerData
  } : {};
  return /*#__PURE__*/React.createElement("div", _extends({
    className: calculatedClassName
  }, dataAttr, attr), children);
};

export default InputContainer;